import QuestionsTable from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/questionsTable/QuestionsTable/QuestionsTable";

export default QuestionsTable;
